import React from 'react'
import { Cell } from 'rsuite-table'
import './EscalationCell.scss'

export type EscalationLevelStyle = {
  background: string
  color: string
}

type EscalationCellProps = {
  rowData?: Record<string, any>
  dataKey: string
  levelMap?: Record<string, EscalationLevelStyle>
}

const DEFAULT_LEVEL_MAP: Record<string, EscalationLevelStyle> = {
  L2: { background: '#FFF7E6', color: '#B45309' },
  L3: { background: '#FFEDD5', color: '#C2410C' },
  L4: { background: '#FEE2E2', color: '#B91C1C' },
  MANUAL: { background: '#E0E7FF', color: '#3730A3' }
}

const EscalationCell: React.FC<EscalationCellProps> = ({
  rowData,
  dataKey,
  levelMap = DEFAULT_LEVEL_MAP,
  ...props
}) => {
  const rawValue = rowData?.[dataKey]
  const value = typeof rawValue === 'string' ? rawValue.trim() : ''

  if (!value) {
    return (
      <Cell {...props}>
        <span className="escalation-cell escalation-cell--empty">—</span>
      </Cell>
    )
  }

  const style = levelMap[value]

  return (
    <Cell {...props}>
      <span
        className="escalation-cell"
        style={
          style
            ? { backgroundColor: style.background, color: style.color }
            : undefined
        }
      >
        {value}
      </span>
    </Cell>
  )
}

export default EscalationCell
